// eslint-disable-next-line import/prefer-default-export
export const TEMPLATES = Object.freeze({
  ONBOARDING_COMPLETE: 'newClientOnBoard',
  RISK_ASSESSMENT_COMPLETE: 'riskTolerance',
  RISK_SCORE_CHANGED: 'riskToleranceUpdateToAdviser',
});
